import React from 'react';
import { Navigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';

const ProtectedRoute = ({ children, roles }) => {
  const { currentUser, authLoading } = useApp();

  if (authLoading) return null;
  if (!currentUser) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(currentUser.role)) return <Navigate to="/" replace />;

  return children;
};

export default ProtectedRoute;
